const IMG = {
  elettricista:
    "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?crop=entropy&cs=srgb&fm=jpg&q=85",
  fabbro:
    "https://images.unsplash.com/photo-1553873002-785d775854c9?crop=entropy&cs=srgb&fm=jpg&q=85",
  idraulico:
    "https://images.unsplash.com/photo-1676210134050-6f12c6898395?crop=entropy&cs=srgb&fm=jpg&q=85",
  spurgo:
    "https://images.unsplash.com/photo-1610016302534-6f67f1c968d8?crop=entropy&cs=srgb&fm=jpg&q=85",
  caldaie:
    "https://images.unsplash.com/photo-1553873002-785d775854c9?crop=entropy&cs=srgb&fm=jpg&q=85",
};

export const PAGINE_SERVIZI = {
  elettricista: {
    nome: "Elettricista",
    titolo: "Elettricista H24 in Lombardia",
    intro:
      "Salvavita che scatta, black-out improvvisi, prese che non funzionano: i nostri elettricisti certificati intervengono giorno e notte in tutta la Lombardia, con strumentazione professionale e ricambi a bordo.",
    immagine: IMG.elettricista,
    voci: [
      { t: "Cortocircuito e salvavita", d: "Il salvavita scatta di continuo? Individuiamo la causa del cortocircuito e ripristiniamo l'impianto in sicurezza." },
      { t: "Guasti e black-out", d: "Casa o negozio senza corrente: diagnosi rapida del guasto e ripristino dell'alimentazione, anche parziale." },
      { t: "Quadri elettrici", d: "Sostituzione e messa a norma di quadri, magnetotermici e differenziali, per abitazioni e attività commerciali." },
      { t: "Prese e interruttori", d: "Riparazione e sostituzione di prese, interruttori e punti luce danneggiati o non funzionanti." },
      { t: "Ripristino corrente", d: "Intervento immediato quando manca la corrente in tutta o in parte dell'abitazione, anche di notte e nei festivi." },
    ],
    perche: [
      "Elettricisti certificati e assicurati",
      "Diagnosi con strumentazione professionale",
      "Preventivo chiaro prima dell'intervento",
      "Attivi 24 ore su 24, anche nei festivi",
    ],
  },
  fabbro: {
    nome: "Fabbro",
    titolo: "Fabbro H24 in Lombardia",
    intro:
      "Chiusi fuori casa, chiave spezzata nella serratura, serranda bloccata: i nostri fabbri arrivano in giornata e di notte in tutta la Lombardia, aprono senza scasso quando possibile e lasciano tutto in sicurezza.",
    immagine: IMG.fabbro,
    voci: [
      { t: "Apertura porte bloccate", d: "Porta chiusa o serratura bloccata? Apriamo senza danneggiare la porta nella maggior parte dei casi." },
      { t: "Cambio serrature", d: "Sostituzione serrature con cilindri europei di ultima generazione, anche dopo furto o smarrimento chiavi." },
      { t: "Serrande e tapparelle", d: "Riparazione e sblocco di serrande di negozi e tapparelle domestiche, con ricambi sempre a bordo." },
      { t: "Cancelli e inferriate", d: "Riparazione di cancelli, inferriate e grate di sicurezza, anche con interventi di saldatura sul posto." },
      { t: "Chiave rotta nella serratura", d: "Estrazione della chiave spezzata senza rovinare il cilindro e, se serve, sostituzione immediata." },
    ],
    perche: [
      "Apertura senza scasso quando possibile",
      "Cilindri europei e serrature di sicurezza",
      "Preventivo chiaro prima dell'intervento",
      "Attivi 24 ore su 24, anche nei festivi",
    ],
  },
  idraulico: {
    nome: "Idraulico",
    titolo: "Idraulico H24 in Lombardia",
    intro:
      "Perdite d'acqua, scarichi intasati, allagamenti: i nostri idraulici intervengono a qualsiasi ora in tutta la Lombardia, fermano il danno e riparano con ricambi garantiti.",
    immagine: IMG.idraulico,
    sottopagina: {
      path: "/servizi/idraulico/perdita-acqua",
      titolo: "Perdita d'acqua?",
      testo: "La emergenza idraulica più frequente merita una pagina dedicata: scopri come interveniamo, passo per passo.",
      cta: "Vai alla pagina dedicata",
    },
    voci: [
      { t: "Perdite d'acqua", d: "Ricerca e riparazione di perdite visibili e occulte, con strumenti di rilevazione non distruttivi." },
      { t: "Stasatura tubi intasati", d: "Disostruzione di lavandini, wc e colonne di scarico con attrezzatura professionale." },
      { t: "Allagamenti", d: "Intervento d'urgenza per fermare l'acqua, prosciugare e mettere in sicurezza i locali allagati." },
      { t: "Rubinetteria e sanitari", d: "Riparazione e sostituzione di rubinetti, miscelatori, cassette wc e sanitari." },
      { t: "Scaldabagno e boiler", d: "Riparazione e sostituzione di scaldabagni elettrici e a gas, per tornare subito ad avere acqua calda." },
    ],
    perche: [
      "Intervento rapido per limitare i danni",
      "Ricambi garantiti e lavoro pulito",
      "Preventivo chiaro prima dell'intervento",
      "Attivi 24 ore su 24, anche nei festivi",
    ],
  },
  spurgo: {
    nome: "Spurgo",
    titolo: "Spurgo e autospurgo H24 in Lombardia",
    intro:
      "Scarichi intasati, fosse biologiche da svuotare, colonne di scarico bloccate: i nostri mezzi di autospurgo intervengono in tutta la Lombardia a qualsiasi ora, per abitazioni, condomini e attività commerciali.",
    immagine: IMG.spurgo,
    voci: [
      { t: "Disostruzione scarichi", d: "Liberiamo wc, lavandini, docce e colonne di scarico con sonde professionali e getti ad alta pressione." },
      { t: "Pulizia fosse biologiche", d: "Svuotamento e pulizia programmata o urgente di fosse biologiche e pozzi neri, con smaltimento a norma." },
      { t: "Videoispezioni", d: "Telecamere nelle tubazioni per trovare ostruzioni, rotture e infiltrazioni senza rompere nulla." },
      { t: "Spurgo pozzi neri", d: "Intervento rapido con autospurgo per pozzi neri pieni o maleodoranti, anche in notturna e nei festivi." },
      { t: "Lavaggio tubazioni", d: "Lavaggio ad alta pressione di tubazioni domestiche e condominiali per prevenire nuove ostruzioni." },
    ],
    perche: [
      "Mezzi di autospurgo propri, sempre pronti",
      "Smaltimento reflui a norma di legge",
      "Preventivo chiaro prima dell'intervento",
      "Attivi 24 ore su 24, anche nei festivi",
    ],
  },
  caldaie: {
    nome: "Caldaie",
    titolo: "Assistenza caldaie e clima H24 in Lombardia",
    intro:
      "Caldaia in blocco d'inverno, acqua fredda, condizionatore fermo d'estate: i nostri tecnici termoidraulici intervengono in tutta la Lombardia, su tutte le marche, giorno e notte.",
    immagine: IMG.caldaie,
    voci: [
      { t: "Blocco caldaia", d: "La caldaia va in blocco e resti al freddo? Diagnosi immediata e riarmo o riparazione sul posto." },
      { t: "Assenza acqua calda", d: "Niente acqua calda sanitaria: controlliamo scambiatori, sonde e pressione e ripristiniamo in giornata." },
      { t: "Manutenzione caldaia", d: "Pulizia, controllo fumi e tagliando annuale per tenere la caldaia efficiente e in regola con gli obblighi di legge." },
      { t: "Riparazione condizionatori", d: "Climatizzatori che non raffreddano o perdono acqua: ricarica gas, pulizia filtri e riparazione." },
      { t: "Sostituzione caldaia", d: "Sostituzione con caldaie a condensazione di ultima generazione, con sopralluogo e installazione rapidi." },
    ],
    perche: [
      "Tecnici abilitati su tutte le marche",
      "Ricambi originali sempre a bordo",
      "Preventivo chiaro prima dell'intervento",
      "Attivi 24 ore su 24, anche nei festivi",
    ],
  },
  "perdita-acqua": {
    nome: "Perdita d'acqua",
    titolo: "Perdita d'acqua: intervento immediato in Lombardia",
    mappaSelect: "Pronto intervento idraulico",
    intro:
      "Una perdita d'acqua non aspetta: ogni minuto può trasformare una goccia in un danno da migliaia di euro. I nostri idraulici intervengono subito in tutta la Lombardia: fermiamo l'acqua, troviamo la perdita e ripariamo.",
    immagine: IMG.idraulico,
    voci: [
      { t: "Ricerca perdita occulta", d: "Macchia sul muro o bolletta alle stelle? Localizziamo la perdita con termocamera e strumenti acustici, senza rompere muri a casaccio." },
      { t: "Riparazione tubazioni", d: "Ripariamo o sostituiamo il tratto danneggiato con materiali garantiti, limitando al minimo l'apertura dei muri." },
      { t: "Allagamenti in casa", d: "Chiudiamo l'acqua, mettiamo in sicurezza e prosciughiamo i locali: prima interveniamo, meno danni restano." },
      { t: "Infiltrazioni e umidità", d: "Risalita di umidità o infiltrazione dal piano di sopra? Troviamo l'origine e coordiniamo la riparazione definitiva." },
      { t: "Rubinetti e raccordi che perdono", d: "Gocciolii continui da rubinetti, flessibili e raccordi: li ripariamo o sostituiamo in un'unica uscita." },
    ],
    perche: [
      "Fermiamo l'acqua prima di tutto, per limitare i danni",
      "Rilevazione non distruttiva con termocamera",
      "Preventivo chiaro prima dell'intervento",
      "Attivi 24 ore su 24, anche nei festivi",
    ],
  },
};
